import { Flex } from '@chakra-ui/react';
import { Checkbox, TextArea } from '@morressier/alembic';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { HELP_TEXT_CHARACTER_LIMIT } from '../constants';
import { trimLeadingWhitespace, validateRequiredTrimmedText } from '../helpers';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

type Props = {
  control: Control<FieldFormValues>;
  errors: FieldErrors<FieldFormValues>;
  isFormDisabled: boolean;
  showHelpText: boolean;
};

const HelpTextField: React.FC<Props> = ({
  control,
  errors,
  isFormDisabled,
  showHelpText
}) => {
  return (
    <>
      <Flex gap={2}>
        <FieldLabel label="Show Help Text" subText="" isRequired={false} />
        <Controller
          name="showHelpText"
          control={control}
          render={({ field }) => (
            <Checkbox
              id="show-help-text"
              name={field.name}
              ariaLabel="Toggle help text"
              isChecked={Boolean(field.value)}
              onChange={event => field.onChange(event.target.checked)}
              disabled={isFormDisabled}
            >
              {''}
            </Checkbox>
          )}
        />
      </Flex>

      {showHelpText ? (
        <Flex direction="column" gap={2}>
          <FieldLabel label="Help Text" subText="" isRequired />

          <Controller
            name="labelHelpText"
            control={control}
            rules={{
              validate: value => {
                if (!showHelpText) return true;

                return validateRequiredTrimmedText({
                  value,
                  label: 'Help text',
                  isDisabled: isFormDisabled
                });
              },
              maxLength: {
                value: HELP_TEXT_CHARACTER_LIMIT,
                message: `Help text cannot exceed ${HELP_TEXT_CHARACTER_LIMIT} characters`
              }
            }}
            render={({ field }) => (
              <TextArea
                name={field.name}
                value={field.value}
                onChange={event =>
                  field.onChange(trimLeadingWhitespace(event.target.value))
                }
                placeholder="Help text"
                resize="vertical"
                characterLimit={HELP_TEXT_CHARACTER_LIMIT}
                isInvalid={!isFormDisabled && Boolean(errors.labelHelpText)}
                errorMessage={
                  !isFormDisabled ? errors.labelHelpText?.message : undefined
                }
                isReadOnly={isFormDisabled}
              />
            )}
          />
        </Flex>
      ) : null}
    </>
  );
};

export default HelpTextField;
